import { FormGroup, Input, Label } from "reactstrap";
import ColorPickerButton from "./ColorPickerButton";

const Step1 = ({ name, setName, logo, setLogo, theme, setTheme, handleNext }) => {
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4 border rounded p-5" style={{ maxWidth: '600px', margin: '0px auto' }}>
      <h2>Company Details</h2>

      <FormGroup className="mt-0 w-100">
        <Label>Company Name</Label>
        <Input
          placeholder="Enter company name"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </FormGroup>

      <FormGroup className="w-100">
        <Label>Company Logo</Label>
        <Input
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleLogoChange}
        />
        {logo && <img src={window.URL.createObjectURL(logo)} alt="Logo Preview" className="mt-2" style={{ width: '100px', height: '100px', objectFit: 'contain' }} />}
      </FormGroup>

      <FormGroup className="w-100">
        <Label>Theme Color</Label>
        <ColorPickerButton
          selectedColor={theme}
          onColorSelect={(color) => setTheme(color)}
          width="100%"
        />
      </FormGroup>
      <div className="d-flex justify-content-center gap-3 mt-4">
        <button className="btn btn-primary" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Step1;
